var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VsChip',{staticClass:"m-0",class:{
    'text-orange-600': _vm.statusColor === 'warning',
    'text-green-600': _vm.statusColor === 'success'
  },attrs:{"color":_vm.statusColor,"transparent":""}},[_vm._v(" "+_vm._s(_vm.statusText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }